import { Component, OnInit, Input, Output, EventEmitter, effect } from '@angular/core';
import { ConversationService } from 'src/app/shared/services/conversation/conversation.service';
import * as _ from 'lodash';
import { LitmusMultiselectDropdownComponent } from 'src/app/litmus-components/litmus-multiselect-dropdown/litmus-multiselect-dropdown.component';
import { NgFor, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
@Component({
  selector: 'app-interaction-parent-child-linkage',
  templateUrl: './interaction-parent-child-linkage.component.html',
  styleUrl: './interaction-parent-child-linkage.component.scss',
  standalone: true,
  imports: [LitmusMultiselectDropdownComponent, NgIf, NgFor, FormsModule]
})
export class InteractionParentChildLinkageComponent implements OnInit {
  @Input() interaction: any = {};
  @Input() readOnly: boolean = false;
  @Output() onChange = new EventEmitter<any>();

  multiSelectSettings = {
    singleSelection: false,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    enableCheckAll: false,
    maxHeight: 200,
    badgeShowLimit: 3,
    classes: 'multiselect-parent'
  };

  multiSelectData: any[] = [];
  multiSelectModel: { [key: string]: any[] } = {};
  initializedParentChild: boolean = false;
  is_parentchild_dom_ready: boolean = false;
  dropdownList: any = [];
  selectedItems: any = [];
  dropdownSettings: any = {
    uniqueIdField: 'id',
    textField: "label",
    categorization: true,
    groupBy: 'group_text'
  };
  fields: any = [];
  constructor(private _conversations: ConversationService) {
    effect(() => {
      let conversationObject: any = this._conversations.conversationObject();
      if (conversationObject) {
        this.fields = Helpers.deepClone(this._conversations?.configuration?.fields)
        this.multiSelectModel = Helpers.deepClone(this._conversations?.multiSelectModel)
        this.initializeParentChild(this.interaction);
        _.each(this.fields, (field: any) => {
          if (field.group_id && field.group_id != this.interaction.field_id) {
            this.multiSelectData.push({
              id: field['field_id'],
              label: field['text'],
              group_text: field['group_text']
            });
          }
        })
        this.multiSelectData = _.uniqBy(this.multiSelectData,'id')
      }
    })
  }

  ngOnInit(): void {
    this.multiSelectData = [];
  }

  onItemSelect(items: any, link: any) {
    if (!link.linked_field_id) {
      link.linked_field_id = []
    }
    this.multiSelectModel[link.field_id] = items
    const selectedItems = this.multiSelectModel[link.field_id] || [];
    // link.linked_field_id = selectedItems.map((item: any) => item.field_id);
    this._conversations.multiSelectModel = this.multiSelectModel;
    this.onChange.emit({
      multiSelectModel: this.multiSelectModel,
      interaction: this.interaction
    })
  }


  initializeParentChild(currentInteraction: any) {
    if ('enableParentChildLinkage' in currentInteraction && currentInteraction.enableParentChildLinkage) {
      this.initializedParentChild = false;
      this.is_parentchild_dom_ready = false;
      this.prepareLinkedFieldList();
      this.parentChildDomPrepared();
    }
  }

  parentChildDomPrepared() {
    this.initializedParentChild = true;
    setTimeout(() => {
      this.is_parentchild_dom_ready = true;
    }, 1000);
  }

  prepareLinkedFieldList() {
    // Get all questions that can be parent questions
    this.multiSelectData = this.interaction.possible_parent_questions?.map((question: any) => {
      return {
        id: question.field_id,
        label: question.text,
        group_text: question.component_type 
      };
    }) || [];
 
    // Initialize the model for each sub-question
    var selected_options = this._conversations.multiOptionsList;
    var defaultSelected_model = this._conversations.multiSelectModel;
    if(!selected_options[this.interaction.field_id]){
        selected_options[this.interaction.field_id] = selected_options['default_options'];
        defaultSelected_model[this.interaction.field_id] = {};
    }
    this.multiSelectData = selected_options[this.interaction.field_id];
    this.multiSelectModel = defaultSelected_model[this.interaction.field_id];
  }

  removeParentLinkage(link: any) {
    if (link.linked_field_id) {
      link.linked_field_id = [];
      this.multiSelectModel[link.field_id] = [];

      this.onChange.emit({
        multiSelectModel: this.multiSelectModel,
        interaction: this.interaction
      })
    }
  }
}
